import React, { Component } from 'react';
import Error404 from 'src/app/components/Error404';

export default class Notfound extends Component {
  render() {
    return <Error404 />;
  }
}
